import script from "./yc-handle.vue?vue&type=script&lang=ts&setup=true"
export * from "./yc-handle.vue?vue&type=script&lang=ts&setup=true"

import "./yc-handle.vue?vue&type=style&index=0&id=94d1856e&lang=css"
import "./yc-handle.vue?vue&type=style&index=1&id=94d1856e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d1856e"]])

export default __exports__